import '@fontsource-variable/newsreader';
import '@fontsource-variable/source-sans-3';
import '@fontsource/ibm-plex-sans-condensed/latin-400.css';
import '@fontsource/ibm-plex-sans-condensed/latin-500.css';
import '@fontsource/ibm-plex-sans-condensed/latin-600.css';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './app';
import { AuthProvider } from './state/auth';
import './styles.css';
import './newsroom.css';

const root = document.getElementById('root');
if (!root) throw new Error('Root element not found');
const storedTheme = localStorage.getItem('incognito.theme');
const initialTheme = storedTheme === 'dark' ? 'dark' : 'light';
document.documentElement.dataset.theme = initialTheme;
document.querySelector('meta[name="theme-color"]')?.setAttribute('content', initialTheme === 'dark' ? '#11151b' : '#f3f5f4');
document.documentElement.dataset.appVersion = '2026.08.06-newsroom.7';

createRoot(root).render(
  <StrictMode>
    <AuthProvider>
      <App />
    </AuthProvider>
  </StrictMode>,
);
